import { render, staticRenderFns } from "./wxMenu.vue?vue&type=template&id=6d408c50&scoped=true"
import script from "./wxMenu.vue?vue&type=script&lang=js"
export * from "./wxMenu.vue?vue&type=script&lang=js"
import style0 from "./wxMenu.vue?vue&type=style&index=0&id=6d408c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d408c50",
  null
  
)

export default component.exports